import React from 'react'

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new window.Date(dateString);
  return date.toLocaleDateString('en-GB'); // dd/mm/yyyy
}

const FormattedDate = ({ value }) => {
  return (
    <span>{formatDate(value)}</span>
  )
}

export default FormattedDate
